import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import VacancyCard from "@/components/VacancyCard";
import ShareModal from "@/components/ShareModal";

export default function Vacancies() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState("all"); // all | continuous | punctual
  const [share, setShare] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    api.get("/vacancies?status=open").then(({ data }) => setItems(data)).finally(() => setLoading(false));
  }, []);

  const filtered = items.filter((v) => filter === "all" || v.service_type === filter);

  return (
    <div className="space-y-8">
      <div>
        <div className="eyebrow">Oportunidades ativas</div>
        <h1 className="font-heading text-5xl mt-2">Vagas disponíveis</h1>
        <p className="text-[var(--ink-soft)] mt-2 max-w-2xl">Apenas vagas com estado aberto. Cada recomendação bem sucedida vale 15 € em Cartão Dá.</p>
      </div>

      <div className="flex flex-wrap gap-2">
        {[
          { k: "all", label: "Todas" },
          { k: "continuous", label: "🟢 Continuidade" },
          { k: "punctual", label: "🔵 Pontuais" },
        ].map((t) => (
          <button
            key={t.k}
            onClick={() => setFilter(t.k)}
            className={`pill-btn !py-2 !px-4 ${filter === t.k ? "pill-primary" : "pill-ghost"}`}
            data-testid={`filter-${t.k}`}
          >
            {t.label}
          </button>
        ))}
      </div>

      {loading ? (
        <div className="text-[var(--ink-soft)]">A carregar…</div>
      ) : filtered.length === 0 ? (
        <div className="card-surface p-10 text-center">
          <p className="text-[var(--ink-soft)]">Ainda não há vagas abertas nesta categoria.</p>
        </div>
      ) : (
        <div className="grid md:grid-cols-2 xl:grid-cols-3 gap-5 stagger">
          {filtered.map((v) => (
            <VacancyCard
              key={v.id}
              v={v}
              onRecommend={() => navigate(`/recommend/${v.id}`)}
              onShare={() => setShare(v)}
              showShare
            />
          ))}
        </div>
      )}

      {share && <ShareModal vacancy={share} onClose={() => setShare(null)} />}
    </div>
  );
}
